document.addEventListener('DOMContentLoaded', () => {
  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, ind) => {
      if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
        entry.target.classList.remove('hidden');
      }
    })
  });

  document.querySelectorAll('.timeline_event').forEach((elem, ind) => {
    elem.classList.add('hidden');
    scrollObserver.observe(elem);
  });

  document.querySelectorAll('.timeline_back_button').forEach((elem) => {
    elem.addEventListener('click', () => {
      let scrollY = window.pageYOffset || doucment.docuemntElement.scrollTop;
      window.scroll({
        top: elem.closest('.wf-block').getBoundingClientRect().top + scrollY,
        behavior: 'smooth'
      })
    })
  })
});